<div class="modal-view" ng-controller="createWorkflowConfigController as workflowConfigCreateCtrl">
    <c-auto-form config="workflowConfigCreateCtrl.autoFormConfig"></c-auto-form>
</div>
